import ky from 'ky';
import Cookies from 'js-cookie';
import { authStore } from '../../entity/auth/auth-store';

let isRefreshing = false;
let refreshSubscribers: ((token: string) => void)[] = [];

const subscribeTokenRefresh = (callback: (token: string) => void) => {
    refreshSubscribers.push(callback);
};

const onRefreshed = (token: string) => {
    refreshSubscribers.forEach((callback) => callback(token));
    refreshSubscribers = [];
};

const refreshToken = async (): Promise<string> => {
    const response = await ky.get('auth/google/refresh', {
        prefixUrl: import.meta.env.VITE_BACKEND_URL,
        credentials: 'include',
    });

    const token = Cookies.get('access_token');
    authStore.setState({
        token,
    });
    Cookies.remove('access_token');

    if (!response.ok || !token) {
        throw new Error('Failed to refresh token');
    }

    return token;
};

export const apiClient = ky.create({
    prefixUrl: import.meta.env.VITE_BACKEND_URL + '/api',
    redirect: 'follow',
    credentials: 'include',
    hooks: {
        beforeRequest: [
            (request) => {
                const { token } = authStore.getState();

                if (token) {
                    request.headers.set('Authorization', `Bearer ${token}`);
                }
            },
        ],
        afterResponse: [
            async (request, options, response) => {
                if (response.status === 401 && !request.headers.has('X-Retry')) {
                    if (isRefreshing) {
                        return new Promise((resolve, reject) => {
                            subscribeTokenRefresh(async () => {
                                try {
                                    request.headers.set('X-Retry', 'true');
                                    const clonedRequest = request.clone();
                                    const newResponse = await ky(clonedRequest, options);
                                    resolve(newResponse);
                                } catch (error) {
                                    reject(error);
                                }
                            });
                        });
                    }
                    isRefreshing = true;
                    try {
                        const newToken = await refreshToken();
                        onRefreshed(newToken);
                        isRefreshing = false;
                        request.headers.set('Authorization', `Bearer ${newToken}`);
                        request.headers.set('X-Retry', 'true');
                        const clonedRequest = request.clone();
                        return ky(clonedRequest, options);
                    } catch (err) {
                        console.error('Token refresh failed', err);
                        isRefreshing = false;
                        return response;
                    }
                }
            },
        ],
    },
});
